import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import CommonStructured from "../../components/common-components/CommonStructured";
import InventoryListings from "../../components/trigger-system/inventories/InventoryListings";
import InventoryForm from "../../components/trigger-system/inventories/InventoryForm";
import { fetchInventoriesData } from "../../redux/plans-reducers/plansSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";

const Inventories = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { inventoriesLoading } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedClaimAtGym: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: allFilters.isActive?.value || "",
    claim_at_gym: allFilters.selectedClaimAtGym?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getInventoriesData = (filters) => {
    dispatch(
      fetchInventoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getInventoriesData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      status: allFilters.isActive?.value || "",
      claim_at_gym: allFilters.selectedClaimAtGym?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.isActive, allFilters.selectedClaimAtGym]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Inventories">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer mod-width-50p ${
              modValues.modName === "add" || modValues.modName === "edit"
                ? "mealsModalContainer"
                : ""
            }`}>
            <ModalHeadAndClose
              title={
                modValues.modName === "add" || modValues.modName === "edit"
                  ? `${modValues.modName} Trigger`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description || "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "image" ? (
              <div className="discussionModalMessage mt30">
                <img
                  src={modValues.rowData?.image}
                  alt="profile"
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              </div>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <InventoryForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getInventoriesData(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Inventories"}
              isReload={() => getInventoriesData(filters)}
              createBtnTxt={"+ Add New Inventory"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="inventories"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={inventoriesLoading}
              searchPlaceHolder="Search by inventory name..."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <InventoryListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getInventoriesData(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Inventories;
